import { Navigate } from "react-router-dom";
import { ROUTES } from "../../constants/routes";

/**
 * ProtectedRoute Component
 * Protects routes that require specific data
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render
 * @param {string[]} props.requiredData - Array of localStorage keys that must exist
 * @param {string} props.redirectTo - Route to redirect to if data is missing (defaults to /doorSchedule)
 */
const ProtectedRoute = ({
  children,
  requiredData = [],
  redirectTo = ROUTES.DOOR_SCHEDULE,
}) => {
  // Check if all required data exists in localStorage
  const hasRequiredData = requiredData.every((key) => {
    const value = localStorage.getItem(key);
    return value !== null && value !== undefined && value !== "null";
  });

  // If required data is missing, redirect to the specified route
  if (!hasRequiredData) {
    console.warn(
      `Missing required data in localStorage: ${requiredData.join(", ")}. Redirecting to ${redirectTo}`
    );
    return <Navigate to={redirectTo} replace />;
  }

  // If all checks pass, render the children
  return children;
};

export default ProtectedRoute;
